class VehicleUtilities {

    /**
     * 
     * @returns - vehicle JSON 
     * accept the csvFile from the metaobject and converting into json
     */
      async tsvVehicleJSON(){
          let response =  await fetch(window.globalVariables.vehicleCsv);
          const csvdata = await response.text();
          
          var fileData = vehicleUtility.CSVToArray(csvdata);
          let arr = {};
  
          fileData.forEach((data, key) => {
              arr[String(key)] = {
                  "year": `${data['Year']}` || null,
                  "make": `${data['Make']}` || null,
                  "model": `${data['Model']}`  || null,
                  "trim":  `${data['Trim']}` || null,
                  "cab_type": data['Cab Type'] || null,
                  "row": `${data['Row']}` || null,
                  "part_number": `${data['Part Number']}` || null
              };
          });
  
          let json = JSON.stringify(arr);
          let vehicleJson = JSON.parse(json);
  
          window.globalVariables.vehicleJson = vehicleJson;
          return vehicleJson;
      }
      /**
       * @returns - heavyequipment JSON
       * accept the csvFile from the metaobject and converting into json
       * 
       */
      async tsvheavyEqJSON(){
      let response =  await fetch(window.globalVariables.heavyvehicleCsv);
      const csvdata = await response.text();
      
      var fileData = vehicleUtility.CSVToArray(csvdata);
      let arr = {};
  
      fileData.forEach((data, key) => {
          arr[String(key)] = {
              "equipment_category": `${data['Type']}` || null,
              "equipment_model_number": `${data['Model Number']}` || null,
              "equipment_part_number": `${data['Part Number']}`  || null,
              "equipment_manufacturer": `${data['Manufacturer']}` || null
          };
      });
  
      let json = JSON.stringify(arr);
      let heavyEquipmentjson = JSON.parse(json);
      window.globalVariables.heavyvehicleJson = heavyEquipmentjson;
      return heavyEquipmentjson;
      }
  
      /**
       * @returns - side by side JSON
       * accept the csvFile from the metaobject and converting into json
       * 
       */
      async tsvsideJSON(){
      let response =  await fetch(window.globalVariables.sidevehicleCsv);
      const csvdata = await response.text();
      
      var fileData = vehicleUtility.CSVToArray(csvdata);
      let arr = {};
  
      fileData.forEach((data, key) => {
          arr[String(key)] = {
              "year": `${data['Year ']}` || null,
              "make": `${data['Make']}` || null,
              "model": `${data['Model']}`  || null,
              "part_number": `${data['Part Number']}` || null,
              "row": `${data['Row']}` || null
          };
      });
  
      let json = JSON.stringify(arr);
      let sideJson = JSON.parse(json);
      window.globalVariables.sidevehicleJson = sideJson;
      return sideJson;
      }
  
      /**
       * @returns - Agri and turf 
       * accept the csvFile from the metaobject and converting into json
       */
      async tsvTurfJSON(){
          let response =  await fetch(window.globalVariables.agriTurfVehicleCsv);
          const csvdata = await response.text();
          
          var fileData = vehicleUtility.CSVToArray(csvdata);
          let arr = {};
      
          fileData.forEach((data, key) => {
          arr[String(key)] = {
              "equipment_category": `${data['Type']}` || null,
              "equipment_manufacturer": `${data['Manufacturer']}` || null,
              "equipment_model_number": `${data['Model Number']}`  || null,
              "equipment_part_number": `${data['Part Number']}` || null
              };
          });
  
          let json = JSON.stringify(arr);
          let turfJson = JSON.parse(json);
          window.globalVariables.agriTurfVehicleJson = turfJson;
          return turfJson;
      }

      async tsvSemiAndHeavyTrucksJSON(){
        let response =  await fetch(window.globalVariables.semiAndHeavyTrucksCSV);
        const csvdata = await response.text();
        
        var fileData = vehicleUtility.CSVToArray(csvdata);
        let arr = {};
    
        fileData.forEach((data, key) => {
            arr[String(key)] = {
                "year": `${data['Year']}` || null,
                "make": `${data['Make']}` || null,
                "model": `${data['Model']}`  || null,
                "part_number": `${data['Part Number']}` || null,
            };
        });
    
        let json = JSON.stringify(arr);
        let vehicleJson = JSON.parse(json);
    
        window.globalVariables.sahdtJson = vehicleJson;
        return vehicleJson;
    }
  
      /**
       * 
       * @param {*} csvData - CSV file
       * @param {*} delimiter 
       * convert csv to array
       * @returns - array 
       */
      CSVToArray(csvData, delimiter) {
          delimiter = (delimiter || ",");
          var pattern = new RegExp((
          "(\\" + delimiter + "|\\r?\\n|\\r|^)" +
          "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
          "([^\"\\" + delimiter + "\\r\\n]*))"), "gi");
          var data = [[]];
          var matches = null;
          while (matches = pattern.exec(csvData)) {
              var matchedDelimiter = matches[1];
              if (matchedDelimiter.length && (matchedDelimiter != delimiter)) {
                  data.push([]);
              }
              if (matches[2]) {
                  var matchedDelimiter = matches[2].replace(
                  new RegExp("\"\"", "g"), "\"");
              } else {
                  var matchedDelimiter = matches[3];
              }
              data[data.length - 1].push(matchedDelimiter);
          }
      let jsonData = this.processData(data);
      return jsonData;
      }
    
      /**
       * 
       * @param {*} sheetData - csvsheet data
       * process csvsheet data
       * apply {key , value } pairs 
       * @returns 
       */
      processData(sheetData) {
          let data = [];
          let headers = [];
      
          sheetData.forEach((csvData, key) => {
          if (key === 0) {
              headers = csvData.map(header => header.replace('.', '_'));
              return;
          }
      
          let mappedData = {};
          csvData.forEach((item, csvKey) => {
              if (headers[csvKey]) {
              if (this.isJSON(item)) {
                  mappedData[headers[csvKey]] = JSON.parse(item);
              } else {
                  mappedData[headers[csvKey]] = item;
              }
              }
          });
      
          data.push(mappedData);
          });
      
          return data;
      }
    
      /**
       * 
       * @param {*} str 
       * @returns - true if json otherwise false
       */
      isJSON(str) {
          try {
          JSON.parse(str);
          return true;
          } catch (e) {
          return false;
          }
      }
  
      /**
       * determine the user vehicles
       */
      _deterMineVehicles(){
          const isCustomer = document.body.classList.contains('customer-loggedin');
          const isCustomerB2B = document.body.classList.contains('b2b-customer');
          
          this.selectedYMMData = [];
          this.selectedTrufData = [];
          this.selectedSideYMMData = [];
          this.selectedHeavyEqipData = [];
          this.selectedSahdtData = [];

          const getDataFromMeta = (selector) => {
                const element = document.querySelector(selector);
                if (!element) return [];

                const rawText = element.textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();

                if (!rawText) return [];

                try {
                    return JSON.parse(rawText);
                } catch (e) {
                    console.error("JSON parse error for selector:", selector, "Raw text:", rawText);
                    return [];
                }
            };
          
          const getDataFromLocalStorage = (key) => {
              const data = localStorage.getItem(key);
              return data ? JSON.parse(data) : [];
          };
          
          if (isCustomer && !isCustomerB2B) {
              this.selectedYMMData = getDataFromMeta('[data-vehile-customer-metafields] [data-vehicle-meta]');
              this.selectedHeavyEqipData = getDataFromMeta('[data-vehile-customer-metafields] [data-hevay-equp-meta]');
              this.selectedSideYMMData = getDataFromMeta('[data-vehile-customer-metafields] [data-side-vehicle-meta]');
              this.selectedTrufData = getDataFromMeta('[data-vehile-customer-metafields] [data-turf-vehicle-meta]');
              this.selectedSahdtData = getDataFromMeta('[data-vehile-customer-metafields] [data-sahdt-vehicle-meta]');
              ['vehicle_data', 'heavy_equipment_data', 'vehicle_data_side', 'turf_data', 'vehicle_data_sahdt'].forEach(key => localStorage.removeItem(key));
          
          } else if (isCustomer && isCustomerB2B) {
              ['vehicle_data', 'heavy_equipment_data', 'vehicle_data_side', 'turf_data', 'vehicle_data_sahdt'].forEach(key => localStorage.removeItem(key));
          
          } else {
              this.selectedYMMData = getDataFromLocalStorage('vehicle_data');
              this.selectedHeavyEqipData = getDataFromLocalStorage('heavy_equipment_data');
              this.selectedSideYMMData = getDataFromLocalStorage('vehicle_data_side');
              this.selectedTrufData = getDataFromLocalStorage('turf_data');
              this.selectedSahdtData = getDataFromLocalStorage('vehicle_data_sahdt');

          }
  
          window.customerSelectedVehicles = {
          'vehicle' : this.selectedYMMData,
          'heavyVehicle' : this.selectedHeavyEqipData,
          'sidebyside': this.selectedSideYMMData,
          'turf': this.selectedTrufData,
          'sahdt': this.selectedSahdtData
          }
      }
  
      // List vehicle in my vehicle modal
      _listVehicle(){
          let listVehicleHTML = "";
          let selectedvehicleHTML = "";
          let selectedvehicleHTMLList = "";
  
          this.selectedYMMData = window.customerSelectedVehicles.vehicle
          this.selectedHeavyEqipData =  window.customerSelectedVehicles.heavyVehicle
          this.selectedSideYMMData = window.customerSelectedVehicles.sidebyside
          this.selectedTrufData = window.customerSelectedVehicles.turf
          this.selectedSahdtData = window.customerSelectedVehicles.sahdt

        //   console.log('ymm==>', this.selectedYMMData);
        //   console.log('heavy===>',this.selectedHeavyEqipData);
        //   console.log('side===>',this.selectedSideYMMData);
        //   console.log('turf===>',this.selectedTrufData);
        //   console.log('sahd==>',this.selectedSahdtData);
        //   console.log(this.selectedTrufData.length);


        

        if (this.selectedHeavyEqipData.length > 0 || this.selectedYMMData.length > 0 || this.selectedSideYMMData.length > 0 || this.selectedTrufData.length > 0 || this.selectedSahdtData.length > 0) {
            const createVehicleHTML = (selectedVehicle) => {
                return `
                <div class="d-flex justify-content-between vehicle_list-item mb-3" data-vehicle-id="${selectedVehicle.id}">
                    <div class="d-flex">
                        <input type="radio" data-list-vehicle-checkbox class="form-check-input me-2 mt-1" id="vehicle-${selectedVehicle.id}" name="list-vehicle" value="${selectedVehicle.equipment_category || selectedVehicle.year} ${selectedVehicle.equipment_manufacturer || selectedVehicle.make} ${selectedVehicle.equipment_model_number || selectedVehicle.model}${selectedVehicle.trim ? ',' + selectedVehicle.trim + ', ' + selectedVehicle.cabType : ''}" ${selectedVehicle.default === true ? 'checked' : ''}>
                        <label class="check1 ps-1 align-items-center d-flex" for="vehicle-${selectedVehicle.id}">
                            <span class="fw-semibold lh-lg text-black"> ${selectedVehicle.equipment_category || selectedVehicle.year} ${selectedVehicle.equipment_manufacturer || selectedVehicle.make} ${selectedVehicle.equipment_model_number || selectedVehicle.model}${selectedVehicle.trim ? ',' + selectedVehicle.trim + ', ' + selectedVehicle.cabType : ''}</span>
                        </label>
                    </div>
                    <a href="#" class="delete_button ms-1 d-inline-block pt-1 text-decoration-none" data-remove-vehicle>
                        <i class="icon-delete text-gray-500 icon-size-17"></i>
                    </a>
                </div>`;
            };
        
            this.selectedHeavyEqipData.forEach(selectedVehicle => {
                listVehicleHTML += createVehicleHTML(selectedVehicle);
            });
        
            this.selectedYMMData.forEach(selectedVehicle => {
                listVehicleHTML += createVehicleHTML(selectedVehicle);
            });
        
            this.selectedTrufData.forEach(selectedVehicle => {
                listVehicleHTML += createVehicleHTML(selectedVehicle);
            });
        
            this.selectedSideYMMData.forEach(selectedVehicle => {
                listVehicleHTML += createVehicleHTML(selectedVehicle);
            });

            this.selectedSahdtData.forEach(selectedVehicle => {
            listVehicleHTML += createVehicleHTML(selectedVehicle);
        });
        
        } else {
            listVehicleHTML = `
            <div class="d-flex justify-content-center mb-3 mt-4">
                <span class="fw-bold">No Vehicle has been added yet.</span>
            </div>`;
        }

        let listMobileVehicleHTML = "";
        if(this.selectedHeavyEqipData.length > 0 || this.selectedYMMData.length > 0 || this.selectedSideYMMData.length > 0 || this.selectedTrufData.length > 0 || this.selectedSahdtData.length> 0){

            const createVehicleHTMLMobile = (selectedVehicle) => {
                return `
                <div class="d-flex justify-content-between vehicle_list-item mb-3" data-vehicle-id="${selectedVehicle.id}">
                <div class="d-flex">
                    <input type="radio" data-list-vehicle-checkbox class="form-check-input me-2 mt-1" id="mobile-vehicle-${selectedVehicle.id}" name="mobile-list-vehicle" value="${selectedVehicle.equipment_category || selectedVehicle.year} ${selectedVehicle.equipment_manufacturer || selectedVehicle.make} ${selectedVehicle.equipment_model_number || selectedVehicle.model}${selectedVehicle.trim ? ',' + selectedVehicle.trim + ', ' + selectedVehicle.cabType : ''}" ${selectedVehicle.default === true ? 'checked' : ''}>
                    <label class="check1 ps-1 align-items-center d-flex" for="mobile-vehicle-${selectedVehicle.id}">
                        <span class="fw-semibold lh-lg text-black"> ${selectedVehicle.equipment_category || selectedVehicle.year} ${selectedVehicle.equipment_manufacturer || selectedVehicle.make} ${selectedVehicle.equipment_model_number || selectedVehicle.model}${selectedVehicle.trim ? ',' + selectedVehicle.trim + ', ' + selectedVehicle.cabType : ''}</span>
                    </label>
                </div>
                <a href="#" class="delete_button ms-1 d-inline-block pt-1 text-decoration-none" data-remove-vehicle>
                    <i class="icon-delete text-gray-500 icon-size-17"></i>
                </a>
            </div>`;
            };

            this.selectedHeavyEqipData.forEach(selectedVehicle => {
                listMobileVehicleHTML += createVehicleHTMLMobile(selectedVehicle);
            });
        
            this.selectedYMMData.forEach(selectedVehicle => {
                listMobileVehicleHTML += createVehicleHTMLMobile(selectedVehicle);
            });
        
            this.selectedTrufData.forEach(selectedVehicle => {
                listMobileVehicleHTML += createVehicleHTMLMobile(selectedVehicle);
            });
        
            this.selectedSideYMMData.forEach(selectedVehicle => {
                listMobileVehicleHTML += createVehicleHTMLMobile(selectedVehicle);
            });

            this.selectedSahdtData.forEach(selectedVehicle => {
                listMobileVehicleHTML += createVehicleHTMLMobile(selectedVehicle);
            });

        } else {
            listMobileVehicleHTML = `
            <div class="d-flex justify-content-center mb-3 mt-4">
                <span class="fw-bold">No Vehicle has been added yet.</span>
            </div>`
        }

        let selectedvehcilemodalSaveEle = document.querySelectorAll('[data-selected-vehicle]');
        if(selectedvehcilemodalSaveEle != null){
            if (this.selectedHeavyEqipData.length > 0 || this.selectedYMMData.length > 0 || this.selectedSideYMMData.length > 0 || this.selectedTrufData.length > 0 || this.selectedSahdtData.length > 0) {
                const createselectedVehicleHTML = (selectedVehicle) => {
                    return `
                    <div class="d-flex justify-content-between vehicle_list-item mb-3" data-vehicle-id="${selectedVehicle.id}">
                        <div class="align-items-center d-flex justify-content-between w-100">
                            <input type="radio" data-list-vehicle-checkbox class="form-check-input me-2 mt-1 d-none " id="vehicle-${selectedVehicle.id}-pdp" name="list-vehicle-pdp" value="${selectedVehicle.equipment_category || selectedVehicle.year} ${selectedVehicle.equipment_manufacturer || selectedVehicle.make} ${selectedVehicle.equipment_model_number || selectedVehicle.model}${selectedVehicle.trim ? ',' + selectedVehicle.trim + ', ' + selectedVehicle.cabType : ''}" ${selectedVehicle.default === true ? 'checked' : ''}>
                            <label class="check1 align-items-center d-none" for="vehicle-${selectedVehicle.id}-pdp">
                                <img src="https://cdn.shopify.com/s/files/1/0766/9245/5708/files/icon-check.svg?v=1742361727" class="d-none block__icon-check">
                                <i class="d-flex me-2 icon-truck icon-size-28" style="color: #d7d9db;"></i>
                                <span class="fw-bold lh-lg text-white"> ${selectedVehicle.equipment_category || selectedVehicle.year} ${selectedVehicle.equipment_manufacturer || selectedVehicle.make} ${selectedVehicle.equipment_model_number || selectedVehicle.model}${selectedVehicle.trim ? ',' + selectedVehicle.trim + ', ' + selectedVehicle.cabType : ''}</span>
                            </label>
                            <div class="block__shopping-text fst-italic fw-bold ls-0 d-none text-gray-300 text-uppercase">currently shopping</div>
                        </div>
                    </div>`;
                };
            
                this.selectedHeavyEqipData.forEach(selectedVehicle => {
                    selectedvehicleHTML += createselectedVehicleHTML(selectedVehicle);
                });
            
                this.selectedYMMData.forEach(selectedVehicle => {
                    selectedvehicleHTML += createselectedVehicleHTML(selectedVehicle);
                });
            
                this.selectedTrufData.forEach(selectedVehicle => {
                    selectedvehicleHTML += createselectedVehicleHTML(selectedVehicle);
                });
            
                this.selectedSideYMMData.forEach(selectedVehicle => {
                    selectedvehicleHTML += createselectedVehicleHTML(selectedVehicle);
                });

                this.selectedSahdtData.forEach(selectedVehicle => {
                    selectedvehicleHTML += createselectedVehicleHTML(selectedVehicle);
                });
            } else {
                selectedvehicleHTML = `
                <div class="d-flex justify-content-center mb-3 mt-4">
                    <span class="fw-bold">No Vehicle has been added yet.</span>
                </div>`;
            }

            selectedvehcilemodalSaveEle.forEach((selectedvehcilemodalSaveEle) => {
                selectedvehcilemodalSaveEle.innerHTML = '';
                selectedvehcilemodalSaveEle.innerHTML = selectedvehicleHTML;
            });
        }

        let selectedvehcilemodalSaveElelist = document.querySelectorAll('[data-selected-vehicle-list]');
        if(selectedvehcilemodalSaveEle != null){
            if (this.selectedHeavyEqipData.length > 0 || this.selectedYMMData.length > 0 || this.selectedSideYMMData.length > 0 || this.selectedTrufData.length > 0 || this.selectedSahdtData.length > 0) {
                const createselectedVehicleHTMLList = (selectedVehicle) => {
                    return `
                    <div class="d-flex justify-content-between vehicle_list-item mb-3" data-vehicle-id="${selectedVehicle.id}">
                        <div class="align-items-center d-flex justify-content-between w-100">
                            <input type="radio" data-list-vehicle-checkbox class="form-check-input me-2 mt-1 d-none " id="vehicle-${selectedVehicle.id}-list" name="list-vehicle-pdp-list" value="${selectedVehicle.equipment_category || selectedVehicle.year} ${selectedVehicle.equipment_manufacturer || selectedVehicle.make} ${selectedVehicle.equipment_model_number || selectedVehicle.model}${selectedVehicle.trim ? ',' + selectedVehicle.trim + ', ' + selectedVehicle.cabType : ''}" ${selectedVehicle.default === true ? 'checked' : ''}>
                            <label class="check1 align-items-center d-none" for="vehicle-${selectedVehicle.id}-list">
                                <img src="https://cdn.shopify.com/s/files/1/0766/9245/5708/files/icon-check.svg?v=1742361727" class="d-none block__icon-check">
                                <i class="d-flex me-2 icon-truck icon-size-28" style="color: #d7d9db;"></i>
                                <span class="fw-bold lh-lg text-white"> ${selectedVehicle.equipment_category || selectedVehicle.year} ${selectedVehicle.equipment_manufacturer || selectedVehicle.make} ${selectedVehicle.equipment_model_number || selectedVehicle.model}${selectedVehicle.trim ? ',' + selectedVehicle.trim + ', ' + selectedVehicle.cabType : ''}</span>
                            </label>
                            <div class="block__shopping-text fst-italic fw-bold ls-0 d-none text-gray-300 text-uppercase">currently shopping</div>
                        </div>
                    </div>`;
                };
            
                this.selectedHeavyEqipData.forEach(selectedVehicle => {
                    selectedvehicleHTMLList += createselectedVehicleHTMLList(selectedVehicle);
                });
            
                this.selectedYMMData.forEach(selectedVehicle => {
                    selectedvehicleHTMLList += createselectedVehicleHTMLList(selectedVehicle);
                });
            
                this.selectedTrufData.forEach(selectedVehicle => {
                    selectedvehicleHTMLList += createselectedVehicleHTMLList(selectedVehicle);
                });
            
                this.selectedSideYMMData.forEach(selectedVehicle => {
                    selectedvehicleHTMLList += createselectedVehicleHTMLList(selectedVehicle);
                });

                this.selectedSahdtData.forEach(selectedVehicle => {
                    selectedvehicleHTMLList += createselectedVehicleHTMLList(selectedVehicle);
                });
            } else {
                selectedvehicleHTMLList = `
                <div class="d-flex justify-content-center mb-3 mt-4">
                    <span class="fw-bold">No Vehicle has been added yet.</span>
                </div>`;
            }

            selectedvehcilemodalSaveElelist.forEach((selectedvehcilemodalSaveElelist) => {
                selectedvehcilemodalSaveElelist.innerHTML = '';
                selectedvehcilemodalSaveElelist.innerHTML = selectedvehicleHTMLList;
            });
        }

        //   let vehcilemodalSaveEles = document.querySelectorAll('[data-my-save-vehcile]')
        //   vehcilemodalSaveEles.forEach((vehcilemodalSaveEle) => {
        //       vehcilemodalSaveEle.innerHTML = '';
        //       vehcilemodalSaveEle.innerHTML = listVehicleHTML;
        //   });
  
          let vehcilemodalSaveEle = document.querySelector('[data-my-save-vehcile]')
          vehcilemodalSaveEle.innerHTML = '';
          vehcilemodalSaveEle.innerHTML = listVehicleHTML;
  
          let vehcilemodalSaveMobileEle = document.querySelector('[data-my-mobile-save-vehcile]')
          vehcilemodalSaveMobileEle.innerHTML = '';
          vehcilemodalSaveMobileEle.innerHTML = listMobileVehicleHTML;


          setTimeout(() => {
            if(document.querySelectorAll("[data-activefilters]").length){
                function getUrlParameter(name) {
                    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
                    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                        results = regex.exec(location.search);
                    return results === null ? "" : decodeURIComponent(results[1])
                }

                let filterActive = getUrlParameter("filter.p.tag");
                let redirect = getUrlParameter("redirect");
                if(filterActive == "" && redirect == "true"){
                    let collection_template = window.globalVariables.templateSuffix

                    let selectedData = localStorage.getItem('currentSelectedDataLabels');
                    // Check for null, "undefined", "", or empty JSON structure as string
                    if (!selectedData || selectedData === 'undefined' || selectedData.trim() === '' || selectedData === '{"id":"","year":"","make":"","model":"","trim":"","cabType":""}') {
                        selectedData = localStorage.getItem('currentSelectedData');
                    }
                    let current_vehicle_id;
                    if (selectedData != null){
                        let current_vehicle_json = JSON.parse(selectedData);
                        current_vehicle_id = current_vehicle_json.id;
                    }
                    if(collection_template == "material"){
                        if (this.selectedYMMData.length > 0) {
                            let ST_selectedyear, ST_selectedmake, ST_selectedmodel, ST_selectedtrim, idToUpdate;
                            const currentYMMData = this.selectedYMMData.find(vehicle => vehicle.id == current_vehicle_id);

                            let vehicleObj = currentYMMData || this.selectedYMMData[0];

                            ST_selectedyear = vehicleObj.year || "";
                            ST_selectedmake = vehicleObj.make || "";
                            ST_selectedmodel = vehicleObj.model || "";
                            ST_selectedtrim = vehicleObj.trim || "";
                            idToUpdate = vehicleObj.id || "";

                            let vehicleString = `${ST_selectedyear} ${ST_selectedmake} ${ST_selectedmodel} ${ST_selectedtrim}`;
                            const vehicleElement = document.querySelector(`.topbar [data-my-save-vehcile] [data-vehicle-id='${idToUpdate}']`);
                            if (vehicleElement) {
                                const checkbox = vehicleElement.querySelector("[data-list-vehicle-checkbox]");
                                if (checkbox) vehicleString = checkbox.value;
                            }

                            document.querySelector('[data-selectyym]').classList.add("d-none");
                            document.querySelectorAll("[data-activefilters]").forEach(element => {
                                element.innerHTML = vehicleString;
                                document.querySelector(".filter-box + div").classList.remove("d-none");
                            });

                            // const isYMMVehicle = this.selectedYMMData.some(vehicle => vehicle.id == idToUpdate);

                            // // Reset default flags
                            // this.selectedYMMData.forEach(vehicle => vehicle.default = false);

                            // if (isYMMVehicle) {
                            //     let selectedYearData = {
                            //         id: "",
                            //         year: "",
                            //         make: "",
                            //         model: "",
                            //         trim: "",
                            //         cabType: ""
                            //     };

                            //     const matchVehicle = this.selectedYMMData.find(v => v.id == idToUpdate);
                            //     if (matchVehicle) {
                            //         selectedYearData = {
                            //             id: matchVehicle.id,
                            //             year: matchVehicle.year || "",
                            //             make: matchVehicle.make || "",
                            //             model: matchVehicle.model || "",
                            //             trim: matchVehicle.trim || "",
                            //             cabType: matchVehicle.cabType || ""
                            //         };
                            //     }

                            //     // Normalize values
                            //     const safeSelectedYear = (selectedYearData.year || "").toLowerCase();
                            //     const safeSelectedMake = (selectedYearData.make || "").toLowerCase();
                            //     const safeSelectedModel = (selectedYearData.model || "").toLowerCase();
                            //     const safeSelectedTrim = (selectedYearData.trim || "").toLowerCase();
                            //     const safeSelectedCabType = (selectedYearData.cabType || "").toLowerCase();

                            //     // For debugging
                            //     console.log("Selected filters:", {
                            //         year: safeSelectedYear,
                            //         make: safeSelectedMake,
                            //         model: safeSelectedModel,
                            //         trim: safeSelectedTrim,
                            //         cabType: safeSelectedCabType
                            //     });

                            //     const vehicleData = Object.values(window.globalVariables.vehicleJson || []);
                            //     this.uniqueRows = [...new Set(vehicleData.map(item => item.row))];

                            //     let filteredRows = [];

                            //     // Step 1: Filter rows
                            //     if (safeSelectedTrim === '' && safeSelectedCabType === '') {
                            //         if (safeSelectedModel !== "") {
                            //             filteredRows = [...new Set(vehicleData.filter(item =>
                            //                 (item.year || "").toLowerCase() === safeSelectedYear &&
                            //                 (item.make || "").toLowerCase() === safeSelectedMake &&
                            //                 (item.model || "").toLowerCase() === safeSelectedModel
                            //             ).map(item => item.row))];
                            //         } else {
                            //             filteredRows = this.uniqueRows;
                            //         }
                            //     } else if (safeSelectedTrim !== '' && safeSelectedCabType === '') {
                            //         filteredRows = [...new Set(vehicleData.filter(item =>
                            //             (item.year || "").toLowerCase() === safeSelectedYear &&
                            //             (item.make || "").toLowerCase() === safeSelectedMake &&
                            //             (item.model || "").toLowerCase() === safeSelectedModel &&
                            //             (item.trim || "").toLowerCase() === safeSelectedTrim
                            //         ).map(item => item.row))];
                            //     } else {
                            //         filteredRows = [...new Set(vehicleData.filter(item =>
                            //             (item.year || "").toLowerCase() === safeSelectedYear &&
                            //             (item.make || "").toLowerCase() === safeSelectedMake &&
                            //             (item.model || "").toLowerCase() === safeSelectedModel &&
                            //             (item.trim || "").toLowerCase() === safeSelectedTrim &&
                            //             ((item.cab_type || item.cabType || "").toLowerCase()) === safeSelectedCabType
                            //         ).map(item => item.row))];
                            //     }

                            //     // Step 2: Get part numbers
                            //     let uniquePartNumbers = [];

                            //     filteredRows.forEach(row => {
                            //         let filteredParts;

                            //         if (safeSelectedTrim === '' && safeSelectedCabType === '') {
                            //             filteredParts = [...new Set(vehicleData.filter(item =>
                            //                 (item.year || "").toLowerCase() === safeSelectedYear &&
                            //                 (item.make || "").toLowerCase() === safeSelectedMake &&
                            //                 (item.model || "").toLowerCase() === safeSelectedModel &&
                            //                 item.row === row
                            //             ).map(item => item.part_number))];
                            //         } else if (safeSelectedTrim !== '' && safeSelectedCabType === '') {
                            //             filteredParts = [...new Set(vehicleData.filter(item =>
                            //                 (item.year || "").toLowerCase() === safeSelectedYear &&
                            //                 (item.make || "").toLowerCase() === safeSelectedMake &&
                            //                 (item.model || "").toLowerCase() === safeSelectedModel &&
                            //                 (item.trim || "").toLowerCase() === safeSelectedTrim &&
                            //                 item.row === row
                            //             ).map(item => item.part_number))];
                            //         } else {
                            //             filteredParts = [...new Set(vehicleData.filter(item =>
                            //                 (item.year || "").toLowerCase() === safeSelectedYear &&
                            //                 (item.make || "").toLowerCase() === safeSelectedMake &&
                            //                 (item.model || "").toLowerCase() === safeSelectedModel &&
                            //                 (item.trim || "").toLowerCase() === safeSelectedTrim &&
                            //                 ((item.cab_type || item.cabType || "").toLowerCase()) === safeSelectedCabType &&
                            //                 item.row === row
                            //             ).map(item => item.part_number))];
                            //         }

                            //         uniquePartNumbers.push(...filteredParts);
                            //     });

                            //     // Step 3: Generate final partsNumber
                            //     const prefixedParts = uniquePartNumbers.map(p => `sku-${p}`);
                            //     const partsNumber = prefixedParts.join(",");

                            //     if (vehicleElement) {
                            //         const checkbox = vehicleElement.querySelector("[data-list-vehicle-checkbox]");
                            //         if (checkbox && checkbox.checked) {
                            //             if (partsNumber) {
                            //                 window.location.href = `/collections/all?filter.p.tag=${partsNumber}`;
                            //             } else {
                            //                 window.location.href = `/collections/all`;
                            //             }
                            //         } else {
                            //             checkbox?.click();
                            //         }
                            //     }
                            // }
                        }
                    }else if(collection_template == "side-by-side"){
                        if(document.querySelectorAll(".side-by-side-seat-covers").length > 0){
                            if (this.selectedSideYMMData.length > 0) {
                                // Step 1: Extract selected vehicle
                                const selectedVehicle = this.selectedSideYMMData.find(v => v.id == current_vehicle_id) || this.selectedSideYMMData[0];

                                const selectedYear = selectedVehicle.year || "";
                                const selectedMake = selectedVehicle.make || "";
                                const selectedModel = selectedVehicle.model || "";
                                const idToUpdate = selectedVehicle.id || "";

                                // Step 2: Build vehicle string from DOM or fallback
                                let vehicleString = `${selectedYear} ${selectedMake} ${selectedModel}`;
                                const vehicleElement = document.querySelector(`.topbar [data-my-save-vehcile] [data-vehicle-id='${idToUpdate}']`);
                                const checkbox = vehicleElement?.querySelector("[data-list-vehicle-checkbox]");

                                if (checkbox?.value) {
                                    vehicleString = checkbox.value;
                                }

                                // Step 3: Update UI
                                document.querySelector('[data-selectyym]')?.classList.add("d-none");
                                document.querySelectorAll("[data-activefilters]").forEach(el => {
                                    el.innerHTML = vehicleString;
                                    document.querySelector(".filter-box + div")?.classList.remove("d-none");
                                });

                                // console.log("idToUpdate", idToUpdate);

                                // // Step 4: Check and mark default vehicle
                                // const isSSVehicle = this.selectedSideYMMData.some(vehicle => vehicle.id == idToUpdate);
                                // if (isSSVehicle) {
                                //     console.log("isSSVehicle");

                                //     // Reset default flags
                                //     this.selectedSideYMMData.forEach(v => v.default = false);

                                //     const matchedVehicle = this.selectedSideYMMData.find(v => v.id == idToUpdate);
                                //     matchedVehicle.default = true;

                                //     const selectedSSYearData = {
                                //         id: matchedVehicle.id,
                                //         year: matchedVehicle.year || "",
                                //         make: matchedVehicle.make || "",
                                //         model: matchedVehicle.model || ""
                                //     };

                                //     // Step 5: Filter parts
                                //     const filteredParts = [
                                //         ...new Set(
                                //             Object.values(window.globalVariables.sidevehicleJson || [])
                                //                 .filter(item =>
                                //                     item.year == selectedSSYearData.year &&
                                //                     item.make == selectedSSYearData.make &&
                                //                     item.model == selectedSSYearData.model
                                //                 )
                                //                 .map(item => item.part_number)
                                //         )
                                //     ];

                                //     const prefixedParts = filteredParts.map(p => `sku-${p}`);
                                //     const partsNumber = prefixedParts.join(",");

                                //     // Step 6: Handle checkbox click or redirect
                                //     if (checkbox) {
                                //         if (checkbox.checked) {
                                //             const url = partsNumber
                                //                 ? `/collections/all?filter.p.tag=${partsNumber}`
                                //                 : `/collections/all`;
                                //             window.location.href = url;
                                //         } else {
                                //             checkbox.click();
                                //         }
                                //     }
                                // }
                            }

                        }else if (this.selectedSahdtData.length > 0) {
                            const currentVehicle = this.selectedSahdtData.find(v => v.id == current_vehicle_id) || this.selectedSahdtData[0];

                            const {
                                year: ST_selectedyear = "",
                                make: ST_selectedmake = "",
                                model: ST_selectedmodel = "",
                                id: idToUpdate = ""
                            } = currentVehicle;

                            const vehicleElement = document.querySelector(`.topbar [data-my-save-vehcile] [data-vehicle-id='${idToUpdate}']`);
                            const checkbox = vehicleElement?.querySelector("[data-list-vehicle-checkbox]");
                            let vehicleString = checkbox?.value || `${ST_selectedyear} ${ST_selectedmake} ${ST_selectedmodel}`;

                            // Update UI
                            document.querySelector('[data-selectyym]')?.classList.add("d-none");
                            document.querySelectorAll("[data-activefilters]").forEach(el => {
                                el.innerHTML = vehicleString;
                                document.querySelector(".filter-box + div")?.classList.remove("d-none");
                            });

                            // Update default flag
                            // const isSahdtVehicle = this.selectedSahdtData.some(v => v.id == idToUpdate);
                            // this.selectedSahdtData.forEach(v => v.default = v.id == idToUpdate);

                            // if (isSahdtVehicle) {
                            //     console.log("isSahdtVehicle");

                            //     const sahdtData = {
                            //         id: idToUpdate,
                            //         year: ST_selectedyear,
                            //         make: ST_selectedmake,
                            //         model: ST_selectedmodel
                            //     };

                            //     // Filter parts
                            //     const filteredParts = [
                            //         ...new Set(
                            //             Object.values(window.globalVariables.sahdtJson || [])
                            //                 .filter(item =>
                            //                     item.year == sahdtData.year &&
                            //                     item.make == sahdtData.make &&
                            //                     item.model == sahdtData.model
                            //                 )
                            //                 .map(item => item.part_number)
                            //         )
                            //     ];

                            //     const partsNumber = filteredParts.map(p => `sku-${p}`).join(",");

                            //     // Handle redirect or checkbox click
                            //     if (checkbox) {
                            //         if (checkbox.checked) {
                            //             window.location.href = partsNumber
                            //                 ? `/collections/all?filter.p.tag=${partsNumber}`
                            //                 : `/collections/all`;
                            //         } else {
                            //             checkbox.click();
                            //         }
                            //     }
                            // }
                        }
                    }else if(collection_template == "equipment-seat-cover"){
                        if (this.selectedHeavyEqipData.length > 0) {
                            // Step 1: Get selected or fallback vehicle
                            const vehicle = this.selectedHeavyEqipData.find(v => v.id == current_vehicle_id) || this.selectedHeavyEqipData[0];

                            const selectedEqipType = vehicle.equipment_category || "";
                            const selectedEqipManufacturer = vehicle.equipment_manufacturer || "";
                            const selectedEqipModel = vehicle.equipment_model_number || "";
                            const idToUpdate = vehicle.id || "";

                            // Step 2: Build vehicle string from checkbox or fallback
                            let vehicleElement = document.querySelector(`.topbar [data-my-save-vehcile] [data-vehicle-id='${idToUpdate}']`);
                            let checkbox = vehicleElement?.querySelector("[data-list-vehicle-checkbox]");
                            let vehicleString = checkbox?.value || `${selectedEqipType} ${selectedEqipManufacturer} ${selectedEqipModel}`;

                            // Step 3: Update UI
                            document.querySelector('[data-selectyym]')?.classList.add("d-none");
                            document.querySelectorAll("[data-activefilters]").forEach(el => {
                                el.innerHTML = vehicleString;
                                document.querySelector(".filter-box + div")?.classList.remove("d-none");
                            });

                            // const isHeavyVehicle = this.selectedHeavyEqipData.some(v => v.id == idToUpdate);
                            // const isSahdtVehicle = this.selectedSahdtData.some(v => v.id == idToUpdate);

                            // if (isHeavyVehicle && !isSahdtVehicle) {
                            //     console.log("isHeavyVehicle");

                            //     // Step 4: Mark default vehicle and prepare structured data
                            //     this.selectedHeavyEqipData.forEach(v => v.default = v.id == idToUpdate);

                            //     const selectedEquipData = {
                            //         id: idToUpdate,
                            //         equipment_category: selectedEqipType,
                            //         equipment_manufacturer: selectedEqipManufacturer,
                            //         equipment_model_number: selectedEqipModel
                            //     };

                            //     // Step 5: Filter parts from heavyvehicleJson
                            //     const filteredParts = [
                            //         ...new Set(
                            //             Object.values(window.globalVariables.heavyvehicleJson || []).filter(item =>
                            //                 item.equipment_category == selectedEquipData.equipment_category &&
                            //                 item.equipment_manufacturer == selectedEquipData.equipment_manufacturer &&
                            //                 item.equipment_model_number == selectedEquipData.equipment_model_number
                            //             ).map(item => item.equipment_part_number)
                            //         )
                            //     ];

                            //     const prefixedParts = filteredParts.map(p => `sku-${p}`);
                            //     const partsNumber = prefixedParts.join(",");

                            //     // Step 6: Handle checkbox redirect
                            //     if (checkbox) {
                            //         if (checkbox.checked) {
                            //             window.location.href = partsNumber
                            //                 ? `/collections/all?filter.p.tag=${partsNumber}`
                            //                 : `/collections/all`;
                            //         } else {
                            //             checkbox.click();
                            //         }
                            //     }
                            // }
                        }
                    }else if(collection_template == "agri-turf"){
                        if (this.selectedTrufData.length > 0) {
                            // Get current or fallback vehicle
                            const vehicle = this.selectedTrufData.find(v => v.id == current_vehicle_id) || this.selectedTrufData[0];
                            const { equipment_category = "", equipment_manufacturer = "", equipment_model_number = "", id = "" } = vehicle;

                            // Update vehicle string from checkbox or fallback
                            const vehicleElement = document.querySelector(`.topbar [data-my-save-vehcile] [data-vehicle-id='${id}']`);
                            const checkbox = vehicleElement?.querySelector("[data-list-vehicle-checkbox]");
                            let vehicleString = checkbox?.value?.trim() || `${equipment_category} ${equipment_manufacturer} ${equipment_model_number}`;

                            // Update UI
                            document.querySelector('[data-selectyym]')?.classList.add("d-none");
                            document.querySelectorAll("[data-activefilters]").forEach(el => {
                                el.innerHTML = vehicleString;
                                document.querySelector(".filter-box + div")?.classList.remove("d-none");
                            });

                            // Proceed only if it's a valid turf vehicle and not in Sahdt
                            // const isTurfVehicle = this.selectedTrufData.some(v => v.id == id);
                            // const isSahdtVehicle = this.selectedSahdtData.some(v => v.id == id);
                            // if (isTurfVehicle && !isSahdtVehicle) {
                            //     console.log("isTurfVehicle");

                            //     // Mark selected vehicle as default
                            //     this.selectedTrufData.forEach(v => v.default = v.id == id);

                            //     // Filter matching parts
                            //     const filteredParts = [
                            //         ...new Set(
                            //             Object.values(window.globalVariables.agriTurfVehicleJson || []).filter(item =>
                            //                 item.equipment_category === equipment_category &&
                            //                 item.equipment_manufacturer === equipment_manufacturer &&
                            //                 item.equipment_model_number === equipment_model_number
                            //             ).map(item => item.equipment_part_number)
                            //         )
                            //     ];

                            //     const partsNumber = filteredParts.map(p => `sku-${p}`).join(",");

                            //     // Handle redirect or checkbox click
                            //     if (checkbox) {
                            //         if (checkbox.checked) {
                            //             window.location.href = partsNumber
                            //                 ? `/collections/all?filter.p.tag=${partsNumber}`
                            //                 : `/collections/all`;
                            //         } else {
                            //             checkbox.click();
                            //         }
                            //     }
                            // }
                        }
                    }
                }
            }
        }, 50);
      }
  
      // List account vehicles
      async _listAccountVehicle(){
        
      let accountVehicleHTML = '';
      if (this.selectedHeavyEqipData.length > 0 || this.selectedYMMData.length > 0 || this.selectedSideYMMData.length > 0 || this.selectedTrufData.length > 0 || this.selectedSahdtData.length > 0) {
  
          const vehicleDataArrays = [
              { data: this.selectedYMMData, type: 'YMM' },
              { data: this.selectedHeavyEqipData, type: 'HeavyEqip' },
              { data: this.selectedTrufData, type: 'Truf' },
              { data: this.selectedSideYMMData, type: 'SideYMM' },
              { data: this.selectedSahdtData, type: 'sahdt' },
          ];
          
          const createVehicleHTMLAcc = (selectedVehicle, type) => {
              const isYMM = type === 'YMM' || type === 'SideYMM' || type == 'sahdt' ;
              const details = isYMM
                  ? `${selectedVehicle.year} ${selectedVehicle.make} ${selectedVehicle.model}`
                  : `${selectedVehicle.equipment_category} ${selectedVehicle.equipment_manufacturer} ${selectedVehicle.equipment_model_number}`;
              const additionalInfo = selectedVehicle.trim ? `, ${selectedVehicle.trim}, ${selectedVehicle.cabType}` : '';

              return `
              <div class="vehicle-item col-12 px-lg-3 px-md-2 px-2" data-vehicle-id="${selectedVehicle.id}">
                  <div class="border border-grey d-flex flex-column h-100 vehicle-card ${selectedVehicle.default === true ? 'bg-gray-100' : ''}">
                      <div class="align-items-center d-block d-sm-flex d-md-block d-lg-flex justify-content-between vehicle-card-body">
                        <div>
                          <div class="align-items-center d-flex vehicle-item-checkbox">
                              <input type="radio" data-list-vehicle-checkbox class="form-check-input me-2 mt-0" id="account-vehicle-${selectedVehicle.id}" name="account-list-vehicle" ${selectedVehicle.default === true ? 'checked' : ''}>
                              <label for="account-vehicle-${selectedVehicle.id}" class="ps-1 fw-semibold">${selectedVehicle.default == true ? 'Currently Shopping For:' : 'Set as current vehicle'}</label>
                          </div>
                          <div class="ps-4 vehicle-name mt-3 ms-1">
                              <h5 class="fw-semibold ${isYMM ? ` mb-2` : 'mb-0'} text-uppercase">${details}</h5>
                              ${isYMM ? `<p class="mb-0 lh-lg pe-xl-5">${details}${additionalInfo}</p>` : ''}
                          </div>
                          <div class="align-items-center d-flex justify-content-start mt-auto vehicle-card-footer">
                              <a href="#" class="fw-semibold lh-lg me-2" data-edit-vehcile data-modal-opener="change-vehicle">Edit Vehicle</a>|
                              <a href="#" class="align-items-center d-flex text-gray-700 ms-2" data-remove-vehicle>Delete</a>
                          </div>
                        </div>
                        <div class="me-xl-3 ms-5 ms-sm-0 ms-md-5 ms-xl-0 mt-4 mt-sm-0 mt-md-4 mt-xl-0 pe-xl-1">
                          <a href="javascript:void(0);" class="btn btn-primary btn-sm" data-shop-vehiclebtn>Shop this vehicle</a>
                        </div>
                      </div>
                  </div>
              </div>`;
          };
  
          vehicleDataArrays.forEach(vehicleArray => {
              vehicleArray.data.forEach(selectedVehicle => {
                  // Create HTML for each vehicle and append it to accountVehicleHTML
                  accountVehicleHTML += createVehicleHTMLAcc(selectedVehicle, vehicleArray.type);
              });
          });
  
      } else {
          accountVehicleHTML = `
          <div class="d-flex justify-content-center mb-3 mt-4">
              <span class="fw-bold">No Vehicle has been added yet.</span>
          </div>`;
      }
  
        let myAccountVehcileList = document.querySelector('[data-vehicle-list-item]');
        
        myAccountVehcileList.innerHTML = accountVehicleHTML;
      }
  
    
  
  
  
  }
  
  var vehicleUtility = new VehicleUtilities();
  
